import React, { ReactNode } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'exoflex';

import { Card } from '../core-ui/index';
import { CARD, TEXT } from '../constants/colors';

type Props = {
  leftComponent: ReactNode;
  rightText: string;
};

export default function SummaryCard({ leftComponent, rightText }: Props) {
  return (
    <Card style={styles.cardStyle} withGradient={true}>
      <View style={styles.rowContainer}>
        <View style={styles.leftContainer}>{leftComponent}</View>
        <View style={styles.rightContainer}>
          <Text weight={'medium'} style={styles.textStyle}>
            {rightText}
          </Text>
        </View>
      </View>
    </Card>
  );
}

const styles = StyleSheet.create({
  cardStyle: {
    flex: 1,
    justifyContent: 'center',
    shadowColor: CARD.shadow.GRADIENT,
    padding: 24,
  },
  linearGradient: {
    flex: 1,
    width: '100%',
  },
  rowContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  leftContainer: {
    alignItems: 'center',
    marginRight: 24,
  },
  rightContainer: {
    flex: 1,
  },
  textStyle: {
    color: TEXT.white,
    fontSize: 18,
    lineHeight: 28,
  },
});
